var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:{'disable': _vm.isBtnDisable},attrs:{"id":_vm.btnId}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.btnMsg)},on:{"click":_vm.clickButton}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }